import { child, get, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { MdContentCopy, MdOutlineNewLabel } from "react-icons/md";
import { RiDeleteBin3Line } from "react-icons/ri";
import { TiArrowBack } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectUserStatus } from "../../common/authenticateDashboard/authSlice";
import { Button } from "../../components";
import Overlay from "../../components/NoDataFoundPage/NoDataFoundPage";
import CustomiseNudgeLoading from "../../components/Skeletons/CustomiseNudgeLoading";
import CustomiseNudgeLoading2 from "../../components/Skeletons/CustomiseNudgeLoading2";
import { defaultNudgeDb } from "../../firebase";
import { getNudgeData } from "../../helper";
import useAuth from "../../helper/CustomHooks/useAuth";
import {
  handleSaveAddPersona,
  handleSaveDeletePersona,
} from "../../helper/customizedNudge";
import CustomizeNudgeStats from "./CustomizeNudgeStats";
import { setGlobalNudgeData } from "./nudgeSlice";
import NudgeWrapper from "./NudgeWrapper";

const CustomizedNudge = () => {
  // let user = useAuth()?.split("@")[0];  // older version

  // new logic to handle user extraction
  let user = useAuth();
  console.log("user in CustomizedNudge : ", user);

  // if(user?.includes("-prod")){
  user = user?.split("@")[0];
  // }
  // else{
  //   user = user?.split("_prod")[0] + "-prod";
  // }

  // console.log("user after processing : ", user);

  const [usersNudgeData, setUsersNudgeData] = useState({});
  const [userPersonaTypes, setUserPersonaTypes] = useState([]);
  const [allPersonaTypes, setAllPersonaTypes] = useState([]);
  const [availablePersonaTypes, setAvailablePersonaTypes] = useState([]);
  const [optimizerStatus, setOptimizerStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState({
    loading: true,
    message: "Loading...",
    error: false,
  });

  const userStatus = useSelector(selectUserStatus)
  const navigate = useNavigate()

  useEffect(() => {
    if (userStatus?.funnel_optimizer) setOptimizerStatus(true);
    // console.log("userStatus : ", userStatus);
    setLoading(false);
  }, [userStatus])

  const dispatch = useDispatch();

  useEffect(() => {
    try {

      const fetchGlobalNudgeData = async () => {
        try {
          const globalNudgeRef = child(ref(defaultNudgeDb), "dashboard-prod/customise_nudge");
          const snapshot = await get(globalNudgeRef);
          if (snapshot.exists()) {
            dispatch(setGlobalNudgeData(snapshot.val()));
            // console.log("Global Data", snapshot.val());
            console.log("Global Data fetched successfully");

          } else {
            console.error("No global nudge data found");
          }
        } catch (error) {
          console.error("Error fetching global nudge data:", error);
        }
      };
      fetchGlobalNudgeData();
      // get all nudge data from database
      getNudgeData(
        user,
        setUsersNudgeData,
        setUserPersonaTypes,
        setAllPersonaTypes,
        setAvailablePersonaTypes
      )
        .then(() => {
          setIsLoading({ loading: false, message: "Loading...", error: false });
        })
        .catch((error) => {
          setIsLoading({ loading: false, message: error, error: true });
        })
        .finally(() => {
          setIsLoading((prev) => ({ ...prev, loading: false }));
        });
    } catch (error) {
      console.error("Error fetching global nudge data:", error);
    }
  }, [user]);

 
  if (loading === true) return <CustomiseNudgeLoading2 />

  if (userStatus?.funnel_optimizer == false) <Overlay />


  return (
    <>
      {optimizerStatus ? (
        <div className="CustomisableNudge bg-color bg-text flex-grow " >
          <div className="flex items-center">
            <button
              className="bg-gray-500 text-white px-4 py-2 rounded-lg border 
    border-gray-500 hover:bg-gray-600 transition-all duration-300 
    ease-in-out font-semibold text-lg mt-4 ms-4 flex justify-center items-center gap-2"
              onClick={() => navigate("/bandit-test#design-type")}
            >
              <TiArrowBack className="text-xl" />
              Back
            </button>

          </div>

          <CustomizedNudgeHeader
            user={user}
            availablePersonaTypes={availablePersonaTypes}
            userPersonaTypes={userPersonaTypes}
          />
          <CustomizeNudgeStats
            usersNudgeData={usersNudgeData}
            userPersonaTypes={userPersonaTypes}
          />
          {isLoading.loading ? (
            <CustomiseNudgeLoading />
          ) : (
            <NudgeWrapper
              userPersonaTypes={userPersonaTypes}
              usersNudgeData={usersNudgeData}
              isLoading={isLoading}
              user={user}
            />
          )}

          {isLoading.error && (
            <p className="text-center text-red-500 font-bold">
              {isLoading.message}
            </p>
          )}
          <ToastContainer />
        </div>
      ) : (
        <CustomiseNudgeLoading2 />
      )}
    </>
  );
};

const CustomizedNudgeHeader = ({
  user,
  availablePersonaTypes,
  userPersonaTypes,
}) => {
  const [isAddPersona, setIsAddPersona] = useState(false);
  const [isCopiedPersona, setIsCopiedPersona] = useState(false);
  const [isDeletePersona, setIsDeletePersona] = useState(false);

  const handleAddPersona = () => {
    setIsAddPersona(true);
  };

  const handleCopyPersona = () => {
    setIsCopiedPersona(true);
  };

  const handleDeletePersona = () => {
    setIsDeletePersona(true);
  };

  const handleCloseCopyPersona = () => {
    setIsCopiedPersona(false);
  };

  const handleCloseAddPersona = () => {
    setIsAddPersona(false);
  };

  const handleCloseDeletePersona = () => {
    setIsDeletePersona(false);
  };

  return (
    <div className="customisable__nudge__header flex flex-col sm:flex-row justify-between items-center mx-6 sm:mx-14 py-4 ">
      <p className="header__text font-bold text-lg sm:text-2xl md:text-3xl">
        Customisable Nudges
      </p>
      <div className="header__buttons flex gap-3 items-center mt-2 sm:mt-0">
        <Button
          Icon={MdContentCopy}
          active={false}
          onClick={handleCopyPersona}
          title="COPY"
        />
        <Button
          Icon={MdOutlineNewLabel}
          active={false}
          onClick={handleAddPersona}
          title="ADD"
        />
        <Button
          Icon={RiDeleteBin3Line}
          active={false}
          onClick={handleDeletePersona}
          title="DELETE"
        />
      </div>
      {isCopiedPersona && (
        <CopyPersona
          user={user}
          availablePersonaTypes={availablePersonaTypes}
          handleCloseAddPersona={handleCloseCopyPersona}
          userPersonaTypes={userPersonaTypes}
        />
      )}
      {isAddPersona && (
        <AddPersona
          user={user}
          availablePersonaTypes={availablePersonaTypes}
          handleCloseAddPersona={handleCloseAddPersona}
          userPersonaTypes={userPersonaTypes}
        />
      )}
      {isDeletePersona && (
        <DeletePersona
          user={user}
          handleCloseDeletePersona={handleCloseDeletePersona}
          userPersonaTypes={userPersonaTypes}
        />
      )}
    </div>
  );
};

const CopyPersona = ({
  user,
  availablePersonaTypes,
  handleCloseAddPersona,
  userPersonaTypes,
}) => {
  const [selectedPersona, setSelectedPersona] = useState(
    userPersonaTypes[0]
  );

  const handleCancel = () => {
    handleCloseAddPersona();
  };

  // save the selected persona to the database and update the userPersonaTypes and added the default property of the persona to the userNudgeData
  const handleSave = () => {
    console.log(user, userPersonaTypes, selectedPersona)
    handleSaveAddPersona(user, userPersonaTypes, selectedPersona, true);
    handleCloseAddPersona();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // availablePersonaTypes.map(
    userPersonaTypes.map(
      (persona, index) =>
        persona.optionValue === value && setSelectedPersona(persona)
    );
  };
  const NudgeModifiedTitle = (title) => {
    return title.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, "");
  }


  return (
    <div className="fixed z-10 inset-0 overflow-hidden">
      <div className="flex items-center justify-center min-h-screen text-center ">
        <div
          className="fixed inset-0 transition-opacity backdrop-blur-sm"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div className="modal__container relative bg-gray-600 text-gray-300 p-4 rounded ">
          <p className="text-center text-xl font-bold mb-4">
            Clone Nudge
          </p>
          {selectedPersona && (
            <p className="text-center text-xl font-bold mb-4">
              You have selected {selectedPersona.optionName}
            </p>
          )}
          <select
            name="addPersona"
            id="addPersona"
            className="mb-4 text-black"
            onChange={handleChange}
          >
            {/* {availablePersonaTypes.map((persona, index) => { */}
            {userPersonaTypes.map((persona, index) => {
              const { optionName, optionValue } = persona;
              return (
                <option key={index} value={optionValue}>
                  {NudgeModifiedTitle(optionName)}
                </option>
              );
            })}
          </select>
          <div className="persona__buttons flex items-center justify-evenly">
            <Button title="CLOSE" onClick={handleCancel} />
            <Button title="SAVE" onClick={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

const AddPersona = ({
  user,
  availablePersonaTypes,
  handleCloseAddPersona,
  userPersonaTypes,
}) => {
  const [selectedPersona, setSelectedPersona] = useState(
    availablePersonaTypes[0]
  );

  const handleCancel = () => {
    handleCloseAddPersona();
  };

  // save the selected persona to the database and update the userPersonaTypes and added the default property of the persona to the userNudgeData
  const handleSave = () => {
    handleSaveAddPersona(user, userPersonaTypes, selectedPersona);
    handleCloseAddPersona();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    availablePersonaTypes.map(
      (persona, index) =>
        persona.optionValue === value && setSelectedPersona(persona)
    );
  };

  return (
    <div className="fixed z-10 inset-0 overflow-hidden">
      <div className="flex items-center justify-center min-h-screen text-center ">
        <div
          className="fixed inset-0 transition-opacity backdrop-blur-sm"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div className="modal__container relative bg-gray-600 p-4 rounded ">
          <p className="text-center text-xl font-bold mb-4">
            Select New Persona
          </p>
          {selectedPersona && (
            <p className="text-center text-xl font-bold mb-4">
              You have selected {selectedPersona.optionName}
            </p>
          )}
          <select
            name="addPersona"
            id="addPersona"
            className="mb-4 text-black"
            onChange={handleChange}
          >
            {availablePersonaTypes.map((persona, index) => {
              const { optionName, optionValue } = persona;
              return (
                <option key={index} value={optionValue}>
                  {optionName}
                </option>
              );
            })}
          </select>
          <div className="persona__buttons flex items-center justify-evenly">
            <Button title="CLOSE" onClick={handleCancel} />
            <Button title="SAVE" onClick={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

const DeletePersona = ({
  user,
  handleCloseDeletePersona,
  userPersonaTypes,
}) => {
  const [selectedPersona, setSelectedPersona] = useState(userPersonaTypes[0]);

  const NudgeModifiedTitle = (title) => {
    return title.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, "");
  }


  const handleCancel = () => {
    handleCloseDeletePersona();
  };

  // save the selected persona to the database and update the userPersonaTypes and added the default property of the persona to the userNudgeData
  const handleSave = () => {
    handleSaveDeletePersona(user, userPersonaTypes, selectedPersona);
    handleCloseDeletePersona();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    userPersonaTypes.map(
      (persona, index) =>
        persona.optionValue === value && setSelectedPersona(persona)
    );
  };

  return (
    <div className="fixed z-10 inset-0 overflow-hidden">
      <div className="flex items-center justify-center min-h-screen text-center ">
        <div
          className="fixed inset-0 transition-opacity backdrop-blur-sm"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div className="modal__container relative bg-gray-600 p-4 rounded ">
          <p className="text-center text-xl font-bold mb-4">Delete Persona</p>
          {selectedPersona && (
            <p className="text-center text-xl font-bold mb-4">
              You have selected {selectedPersona.optionName}
            </p>
          )}
          <select
            name="addPersona"
            id="addPersona"
            className="mb-4 text-black"
            onChange={handleChange}
          >
            {userPersonaTypes.map((persona, index) => {
              const { optionName, optionValue } = persona;
              return (
                <option key={index} value={optionValue}>
                  {NudgeModifiedTitle(optionName)}
                </option>
              );
            })}
          </select>
          <div className="persona__buttons flex items-center justify-evenly">
            <Button title="CLOSE" onClick={handleCancel} />
            <Button title="DELETE" onClick={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizedNudge;
